var socketWebworker = require('./socket.worker');

// The usage of bind here fixes an issue in development (CRAB-18549), where
// IE 11 and Edge (Edge HTML) would barf with a "Invalid calling object" error.
// noinspection JSUnresolvedFunction
self.onmessage = socketWebworker.default(global.postMessage.bind(global), global.WebSocket.bind(global));
